// LISTA COLADA VIRA TEXTO NUMERADO (29/09/2026).
//
// Pedido da Dra. Jullya: ela copiava uma mensagem com "1. CNIS / 2. CTPS…" e,
// ao colar no campo de resposta, a numeração sumia. Na tela a lista é <ol>: o
// número é desenhado, não é texto — e o editor do WhatsApp não tem lista (o
// WhatsApp não tem), então jogava a estrutura fora e ficavam só os itens.
//
// Aqui a lista vira o que o WhatsApp mostra: um parágrafo com uma linha por
// item, "1. …" (respeitando `start`) ou "• …". Vale para lista vinda de
// qualquer lugar: desta tela, do Word, do Google Docs, de um site.

const BLOCOS = new Set([
  'P',
  'DIV',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'BLOCKQUOTE',
]);

const temLista = html => /<(ol|ul)[\s>]/i.test(html || '');

// O conteúdo de um <li> numa linha só: blocos internos viram espaço.
function conteudoDoItem(li, documento) {
  const fragmento = documento.createDocumentFragment();
  Array.from(li.childNodes).forEach((no, i) => {
    if (BLOCOS.has(no.nodeName)) {
      if (i > 0) fragmento.append(' ');
      fragmento.append(...Array.from(no.childNodes));
    } else {
      fragmento.append(no);
    }
  });
  return fragmento;
}

function listaComoParagrafo(lista, documento) {
  const ordenada = lista.tagName === 'OL';
  let numero = parseInt(lista.getAttribute('start') || '1', 10) || 1;
  const paragrafo = documento.createElement('p');
  Array.from(lista.children)
    .filter(item => item.tagName === 'LI')
    .forEach((item, i) => {
      if (i > 0) paragrafo.append(documento.createElement('br'));
      paragrafo.append(ordenada ? `${numero}. ` : '• ');
      numero += 1;
      paragrafo.append(conteudoDoItem(item, documento));
    });
  return paragrafo;
}

export function listasComoTexto(html) {
  if (!temLista(html)) return html;

  const documento = new DOMParser().parseFromString(html, 'text/html');
  // De dentro para fora: a lista aninhada vira texto antes da que a contém.
  Array.from(documento.querySelectorAll('ol, ul'))
    .reverse()
    .forEach(lista => lista.replaceWith(listaComoParagrafo(lista, documento)));
  return documento.body.innerHTML;
}
